import { inject, Injectable } from "@angular/core";
import { ComponentStore, tapResponse } from "@ngrx/component-store";
import { iif, switchMap, tap } from "rxjs";
import { MarketplaceGlossary, RegulatedGlossary } from "src/app/common/dto/glossary";
import { LoadingResponse } from "src/app/common/interfaces/loading-response";
import { GpCmsService } from "src/app/core/services/gp-cms.service";
import { JsonsService } from "src/app/core/services/jsons.service";
import {
  createFulfilledResponse,
  createLoadingResponse,
  createRejectedResponse
} from "src/app/shared/utils/loading-response";

export interface GlossaryDialogState {
  data: LoadingResponse<RegulatedGlossary | MarketplaceGlossary | null>;
}

@Injectable()
export class GlossaryDialogComponentStore extends ComponentStore<GlossaryDialogState> {
  private readonly jsonsService = inject(JsonsService);
  private readonly gpCmsService = inject(GpCmsService);

  constructor() {
    super({ data: createLoadingResponse(null) });
  }

  readonly result$ = this.select((state) => state.data.result);
  readonly loading$ = this.select((state) => state.data.loading);

  readonly loadList = this.effect<{ type: "regulated" | "marketplace" }>((params$) => {
    return params$.pipe(
      tap(() => this.patchState({ data: createLoadingResponse(null) })),
      switchMap(({ type }) =>
        iif(() => type === "regulated", this.jsonsService.getGlossaries(), this.gpCmsService.getGlossaries()).pipe(
          tapResponse(
            (result) => this.patchState({ data: createFulfilledResponse(result) }),
            () => this.patchState({ data: createRejectedResponse() })
          )
        )
      )
    );
  });
}
